import { render, staticRenderFns } from "./OrderComplain.vue?vue&type=template&id=18f8d111&scoped=true"
import script from "./OrderComplain.vue?vue&type=script&lang=ts"
export * from "./OrderComplain.vue?vue&type=script&lang=ts"
import style0 from "./OrderComplain.vue?vue&type=style&index=0&id=18f8d111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8d111",
  null
  
)

export default component.exports